import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-barcode-print',
  templateUrl: './barcode-print.component.html',
  styleUrls: ['./barcode-print.component.scss']
})
export class BarcodePrintComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

}
